module.exports = __webpack_public_path__ + "static/media/tyson-only.95f19023.png";